import "./Card.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import base_url from "../../api";

const Card = ({ id, image, name, description, price }) => {
  // ✅ Handle both array & object formats for images
  let imgSrc = "default.jpg";

  if (image) {
    if (Array.isArray(image) && image.length > 0) {
      imgSrc = image[0]; // old array format
    } else if (typeof image === "object") {
      const firstColor = Object.keys(image)[0];
      if (firstColor && image[firstColor]?.length > 0) {
        imgSrc = image[firstColor][0]; // new object format
      }
    }
  }

  // ✅ Initialize cart state from localStorage
  const [cartproducts, setCartproducts] = useState(() => {
    const saved = localStorage.getItem("itemsId");
    return saved ? JSON.parse(saved) : [];
  });

  const AddToCart = (e, ID) => {
    e.preventDefault();
    e.stopPropagation();

    const saved = localStorage.getItem("itemsId");
    const currentCart = saved ? JSON.parse(saved) : [];

    if (currentCart.includes(ID)) {
      toast.warning("Already Added in cart!", { position: "top-right", autoClose: 2000 });
    } else {
      toast.success("Product added in cart!!", { position: "top-right", autoClose: 2000 });
      const updatedCart = [...currentCart, ID];
      setCartproducts(updatedCart);
      localStorage.setItem("itemsId", JSON.stringify(updatedCart));
      console.log("Cart:", updatedCart);
    }
  };

  return (
    <div className="card-container">
      <div className="card">
        <Link to={`/productPage?id=${id}`}>
          <div
            className="card-image"
            style={{
              backgroundImage: `url(${base_url}/images/${imgSrc})`,
            }}
          >
            {/* <button className="add-to-cart-btn" onClick={(e) => AddToCart(e, id)}>
              <FontAwesomeIcon icon={faShoppingCart} /> Add to Cart
            </button> */}
          </div>
        </Link>

        <div className="card-info">
          <p className="product-name">{name}</p>
          <p className="price">C${price}</p>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Card;
